import { getSpacingValue, getSpacing } from '../../styles/spacing.js';

var TREE_HORIZONTAL_SEPARATION = getSpacingValue(2);
var TREE_LINE_HEIGHT = getSpacing(8);
var TREE_DRAG_TYPE = "node";
var TREE_DEFAULT_BORDER_WIDTH = 1;
var TREE_DRAG_NODE_Z_INDEX = 100;
var TREE_VERTICAL_DASH_OFFSET = 7;
var TREE_DRAG_ANIM_TIME = "0.15s";
var TREE_DRAG_ANIM_CURVE = "ease-out";

export { TREE_DEFAULT_BORDER_WIDTH, TREE_DRAG_ANIM_CURVE, TREE_DRAG_ANIM_TIME, TREE_DRAG_NODE_Z_INDEX, TREE_DRAG_TYPE, TREE_HORIZONTAL_SEPARATION, TREE_LINE_HEIGHT, TREE_VERTICAL_DASH_OFFSET };
